import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material";
import { InternationalisationService } from "../forked/angular-internationalisation";
import { CoreLanguages } from "../languages";
import { SnackBarMessageType } from "../shared/contentTypes";

export enum snackBarMessageKey {
  successfullyExecuted = "successfullyExecuted",
  unkownLocation = "unkownLocation",
  failed = "failed",
  locationNotFound = "locationNotFound",
  UpdateFailed = "UpdateFailed",
  deviceOffline = "deviceOffline",
  deviceOnline = "deviceOnline",
  unsupported = "unsupported",
  scanAgain = "scanAgain",
  copiedToClipboard = "copiedToClipboard",
  allMembersAreReady = "allMembersAreReady",
  retailDeliveryCountryMissing = "retailDeliveryCountryMissing",
}

@Injectable({
  providedIn: "root"
})
export class SnackBarService {
  private snackBarConfig: MatSnackBarConfig;
  constructor(public snackBar: MatSnackBar) {
    this.snackBarConfig = {};
  }

  /** set config of SnackBar
   * @param messageType Define the type of message. it could be error, succes or warning message. 
   * @param duration set duration for showing SnackBar message
   * @param horizontalPosition Horizontal alignment of SnackBar. 'start' | 'center' | 'end' | 'left' | 'right'
   * @param verticalPosition Vertical alignment of SnackBar. 'top' | 'bottom'
   */
  private setSnackBarConfing(messageType, duration, horizontalPosition, verticalPosition): void {
    const me = this;
    me.snackBarConfig.duration = duration;
    me.snackBarConfig.panelClass = messageType;
    me.snackBarConfig.horizontalPosition = horizontalPosition;
    me.snackBarConfig.verticalPosition = verticalPosition;
  }

  /** Shows SnackBar base on setting that are received by parameter
   * @param message message that is shown in SnackBar
   * @param messageType Define the type of message. it could be error, succes or warning message.
   * @param duration set duration for showing SnackBar message
   * @param horizontalPosition Horizontal alignment of SnackBar. 'start' | 'center' | 'end' | 'left' | 'right'
   * @param verticalPosition Vertical alignment of SnackBar. 'top' | 'bottom'
   */

  public ShowMessage(messageKey: string, messageType: SnackBarMessageType, duration = 3000, horizontalPosition = "left", verticalPosition = "bottom"): void {
    const me = this;
    me.setSnackBarConfing(messageType, duration, horizontalPosition, verticalPosition);
    let msg = CoreLanguages[InternationalisationService.locale].phSnackBarMessages[messageKey];
    if (!msg)
      msg = messageKey;
    me.snackBar.open(msg, null, me.snackBarConfig);
  }

  /** The error code must be unique and greater than 0. The last recorded code is noted in the comment for marking.
  //! Add the error code on calling the function
  //! Update the comment with the last error code
  // * The last error code: 132
  */
  public ShowErrorMessageFailed(error_code: number = 0, duration = 3000, horizontalPosition = "left", verticalPosition = "bottom",): void {
    const me = this;
    const messageType = SnackBarMessageType.Error;
    const messageKey = snackBarMessageKey.failed;
    me.setSnackBarConfing(messageType, duration, horizontalPosition, verticalPosition);
    let msg = CoreLanguages[InternationalisationService.locale].phSnackBarMessages[messageKey];
    if (!msg)
      msg = messageKey;
    msg += " (error: " + error_code.toString() + ")";
    me.snackBar.open(msg, null, me.snackBarConfig);
  }

  public ShowMessageUserGroupChange(userName: string, action: "joined" | "left"): void {
    const me = this;
    const duration = 3000;
    const horizontalPosition = "left";
    const verticalPosition = "bottom";
    me.setSnackBarConfing(SnackBarMessageType.Info, duration, horizontalPosition, verticalPosition);

    let messageKey = action === "joined" ? "userJoinedTheGroup" : "userLeftTheGroup";
    let msg = CoreLanguages[InternationalisationService.locale].phSnackBarMessages[messageKey].replace("{userName}", userName);

    if (!msg) {
      msg = `User ${action} the group`;
    }
    me.snackBar.open(msg, 'OK', me.snackBarConfig);
  }


}
